module.exports = __webpack_public_path__ + "img/ass12.80055631.png";